var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        [
          _c("div", { staticClass: "tit_tl", on: { click: _vm.goDown } }, [
            _vm._v("打开APP，查看全部评论")
          ]),
          _c("GCDOWN", {
            attrs: { "down-show": _vm.DownShow },
            on: { showDwon: _vm.getshowDonw }
          }),
          _c("GCGUIDE", {
            attrs: { "down-show": _vm.weiXin },
            on: { showDwon: _vm.getWechat }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }